import initialState from './initialState';
import { types } from '../actions/teamActions';

export default function teamReducer(state = initialState.teamReducer, action) {
  switch (action.type) {
    case types.CREATE_TEAM_SUCCESS:
    case types.UPDATE_TEAM_SUCCESS:
      return { ...state, teams: [...state.teams.filter((team) => team.id !== action.team.id), action.team] };
    case types.DELETE_TEAM_SUCCESS:
      return { ...state, teams: state.teams.filter((team) => team.id !== action.id) };
    case types.LOAD_TEAM_LIST_SUCCESS:
      return { ...state, teams: action.teamList, isLoading: false };
    case types.TEAM_LIST_LOADING_START:
      return { ...state, teams: [], isLoading: true };
    case types.TEAM_LIST_LOADING_STOP:
      return { ...state, teams: [], isLoading: false };
    default:
      return state;
  }
}
